import { CFormTextarea } from '@coreui/react'
import React, { useEffect, useRef } from 'react'

const GraytextareaAdjustable = ({ autoResize = true, disabled = false, style, showTreatmentAsAccordion, ...props }) => {
  const textareaRef = useRef(null)

  const userData = JSON.parse(localStorage.getItem('user'))
  const role = userData?.Role

  const handleAutoResize = () => {
    if (!autoResize || !textareaRef.current) return

    const el = textareaRef.current
    el.style.height = props?.height ? props.height : 'auto'
    el.style.height = `${el.scrollHeight}px`
  }

  useEffect(() => {
    handleAutoResize()
  }, [props.value])

  return (
    <CFormTextarea
      ref={textareaRef}
      disabled={disabled}
      onInput={handleAutoResize}
      style={{
        ...style,
        height: autoResize ? 'auto' : props.height,
        resize: 'none',
        overflow: 'hidden',
        border: '1px solid rgb(113, 113, 113)',
        borderRadius: '8px',
        color: role === 'provider' ? 'var(--ui-text-primary, inherit)' : 'var(--ui-text-primary, inherit)',
        background: 'transparent',
        backgroundColor: 'transparent',
        fontSize: '14px',
      }}
      {...props}
    />
  )
}

export default GraytextareaAdjustable
